module.exports = __webpack_public_path__ + "b38b18ef2f0750f048065f01025967cc.gif";